'use strict';


/* eslint new-cap: 0 */
var Emitter   = require('cjs-emitter'),

    model = window.gSTB.GetDeviceModelExt ? window.gSTB.GetDeviceModelExt() : window.gSTB.GetDeviceModel();


window.top.stbEvent = window.stbEvent = new Emitter();

/**
 * Event on messages from a window.
 *
 * @event module:stb/app#message
 * @type object
 * @property {boolean} broadcast message flag
 * @property {string} message received from window
 * @property {object} data received from window
 */

/**
 * Fires mag device media events.
 *
 * @param {number} event code
 * @param {string} info associated data in **JSON** format
 */
window.stbEvent.onEvent = function ( event, info ) {
    if ( DEVELOP ) {
        debug('mag')('stbEvent.onEvent1 ' + event);
    }

    try {
        event = parseInt(event, 10);
    } catch ( error ) {
        if ( DEVELOP ) {
            debug('mag')('stbEvent.onEvent2 ' + error);
        }

        return;
    }

    if ( DEVELOP ) {
        debug('mag')(event);
    }

    // if ( event === hdmiConnectedEvent ) {
    //     if ( window.core.environment.hdmi_event_delay !== '0' ) {
    //         clearTimeout(hdmiTimeout);
    //         if ( window.gSTB.GetStandByStatus() ) {
    //             standByToggle(true);
    //         }
    //     }

    //     return;
    // }
    // if ( event === hdmiDisconnectedEvent ) {
    //     if ( DEVELOP ) {
    //         debug('mag')(window.core.environment.hdmi_event_delay);
    //     }
    //     if (  window.core.environment.hdmi_event_delay !== '0' ) {
    //         hdmiTimeout = setTimeout(function () {
    //             if ( !window.gSTB.GetStandByStatus() ) {
    //                 standByToggle(true);
    //             }
    //         });
    //         standByToggle(true);
    //     }

    //     return;
    // }

    if ( this.events['media'] ) {
        // additional data
        if ( info ) {
            try {
                info = JSON.parse(info);
            } catch ( error ) {
                info = {};
            }
        }

        // notify listeners
        this.emit('media', {code: event, info: info});
    }
};


/**
 * Fires event on broadcast messages from a window.
 *
 * @param {number} windowId that sent message
 * @param {string} message text
 * @param {Object} data in sent message
 * @fires module:/stb/app#message
 */
window.stbEvent.onBroadcastMessage = function ( windowId, message, data ) {
    if ( this.events['message'] ) {
        // notify listeners
        this.emit('message', {
            broadcast: true,
            windowId: windowId,
            message: message,
            data: data
        });
    }
};


/**
 * Fires event on messages from a window.
 *
 * @param {number} windowId that sent message
 * @param {string} message text
 * @param {Object} data in sent message
 * @fires module:/stb/app#message
 */
window.stbEvent.onMessage = function ( windowId, message, data ) {
    // if ( message === 'portal.standbyMode' ) {
    //     standByToggle();

    //     return;
    // }

    if ( this.events['message'] ) {
        // notify listeners
        this.emit('message', {
            broadcast: false,
            windowId: windowId,
            message: message,
            data: data
        });
    }
};

/**
 * Fires event of callback on internet browser link clicked to ask user what to do with link: play or download.
 *
 * @param {string} mime file type
 * @param {string} url resource link
 *
 * @fires module:/mag/app#media:available
 */
window.stbEvent.onMediaAvailable = function ( mime, url ) {
    if ( this.events['media:available'] ) {
        // notify listeners
        this.emit('media:available', {mime: mime, url: url});
    }
};

/**
 * Fires new internet connection state event.
 *
 * @param {boolean} state of internet connection
 * @fires module:/mag/app#internet:state
 */
window.stbEvent.onNetworkStateChange = function ( state ) {
    if ( this.events['internet:state'] ) {
        // notify listeners
        this.emit('internet:state', {state: state});
    }
};

/**
 * Fires document loading progress changes event.
 *
 * @param {number} progress of document loading
 * fires module:/mag/app#browser:progress
 */
window.stbEvent.onWebBrowserProgress = function ( progress ) {
    if ( this.events['browser:progress'] ) {
        // notify listeners
        this.emit('browser:progress', {progress: progress});
    }
};

/**
 * Fires browser web window activation event.
 *
 * fires module:/mag/app#window:focus
 */
window.stbEvent.onWindowActivated = function () {
    if ( this.events['window:focus'] ) {
        // notify listeners
        this.emit('window:focus');
    }
};


module.exports = {
    unload: function () {
        if ( !NANOCORE ) {
            if ( window.stbPlayerManager ) {
                window.stbPlayerManager.list.forEach(function ( player ) {
                    var width = screen.width,
                        height = screen.height;

                    switch ( window.gSTB.RDir('vmode') ) {
                        case '480i':
                        case '480p':
                            width = 720;
                            height = 480;
                            break;

                        case '576i':
                        case '576p':
                            width = 720;
                            height = 576;
                            break;

                        case '720p':
                        case '720p60':
                            width = 1280;
                            height = 720;
                            break;

                        case '1080i':
                        case '1080i60':
                        case '1080p':
                        case '1080p60':
                            width = 1920;
                            height = 1080;
                            break;

                    }
                    player.stop();
                    player.setViewport({
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    });
                });
            } else {
                window.gSTB.Stop();
            }
        }

        if ( MODE === 'PORTAL' ) {
            window.gSTB.EnableAppButton(true);
            window.gSTB.EnableVKButton(true);
            window.gSTB.EnableServiceButton(true);
        }
    },
    load: function () {
        if ( !NANOCORE ) {
            window.gSTB.EnableAppButton(false);
            if ( model.indexOf('256') === -1 ) {
                window.gSTB.EnableServiceButton(false);
            }
        }
    },
    init: function () {
        var rootPath;

        if ( NANOCORE ) {
            if ( window.top.location.href.indexOf('load=true') !== -1 ) {
                window.top.stbWebWindow.close();
            }
        } else {
            if ( MODE === 'PORTAL' ) {
                if ( DEVELOP ) {
                    rootPath = location.protocol + '//' + location.host + location.pathname.replace('develop.html', '') + '../../';
                } else {
                    rootPath = location.protocol + '//' + location.host + location.pathname.replace('index.html', '') + '../../';
                }

                window.gSTB.SetSettingsInitAttr(JSON.stringify({
                    url: rootPath + 'system/settings/index.html',
                    backgroundColor: '#000'
                }));
                window.stbWindowMgr.setVirtualKeyboardInitAttr(JSON.stringify({
                    url: rootPath + 'system/keyboard/index.html'
                }));

                window.stbWindowMgr.setWebFaceInitAttr(JSON.stringify({
                    // URL possible options:
                    // mode = Choose page to display Bookmarks = 1, Browser = 2
                    // url = if mode is equal to 2, trying to browsing this link
                    // view = if isset right url and mode is equal to 2, display browser in full screen
                    url: rootPath + 'public/app/ibman/index.html?mode=2'
                }));
                window.gSTB.EnableServiceButton(true);
            } else {
                window.gSTB.EnableServiceButton(false);
            }
            window.moveTo(0, 0);
            window.resizeTo(screen.width, screen.height);
            window.gSTB.InitPlayer();
            window.gSTB.EnableAppButton(true);
            window.gSTB.EnableVKButton(false);
        }

        if ( window.gSTB.SetNativeStringMode ) {
            window.gSTB.SetNativeStringMode(true);
        }

        if ( MODE === 'PORTAL' ) {
            window.gSTB.ShowVirtualKeyboard(true);
        }
    }
};
